<template>
  <div class="p-4">
    <div class="row">
      <div class="col-12">
        <div class="label mt-2 mb-1">Select Vendors</div>

        <grid
          v-if="vendors.length"
          :data-items="vendors"
          :columns="columns"
          :style="{ height: '500px', maxHeight: '500px' }"
          style="font-size: 0.9rem"
          :filterable="false"
          :cell-render="'cellTemplate'"
          @rowclick="onRowClick"
        >
          <template v-slot:cellTemplate="{ props }">

            <template v-if="props.dataItem['isExternallyOrderedVendor'] === true">
              <td v-if="props.field === 'selected'">
                <div class="d-flex align-items-center">
                  <input
                      type="checkbox"
                      class="form-check-inputs"
                      id="exampleCheck1"
                      :checked="isSelected(props.dataItem['id'])"
                      @input="onRowClick(props)"
                  />
                  <i v-if="selectedVendors.indexOf(props.dataItem['id']) !== -1"
                     class="far fa-info-circle ml-2" v-b-tooltip="'Vendor already added to MaterialRequest'"></i>
                </div>
              </td>

              <td v-else-if="props.field === 'name'">
                <span class="badge badge-info">EXTERNALLY ORDERED</span> {{ props.dataItem[props.field] }}
              </td>

              <td v-else>
                --
              </td>
            </template>
            <template v-else>
            <td v-if="props.field === 'name'">
              <div class="d-flex justify-content-between items-center">
                <div>
              {{ props.dataItem[props.field] }}
              </div>
              <span class="badge" v-if="props.dataItem['isAmosVendor']">
                AMOS
              </span>
              </div>
            </td>

              <td v-else-if="props.field === 'favorite'">
                <i class="far fa-star" v-if="props.dataItem['isFavorite']"></i>
              </td>

            <td v-else-if="props.field === 'email'">
              <div v-for="contact in props.dataItem['vendorContacts'].filter(_=> _.contactType == 'email')" :key="contact.id">
                <i class="far fa-envelope"></i>
                {{ contact.contact }}
              </div>

            </td>

            <td v-else-if="props.field === 'selected'">
              <div class="d-flex align-items-center">
              <input
                type="checkbox"
                class="form-check-inputs"
                id="exampleCheck1"
                :checked="isSelected(props.dataItem['id'])"
                @input="onRowClick(props)"
              />

              <i v-if="selectedVendors.indexOf(props.dataItem['id']) !== -1"
                  class="far fa-info-circle ml-2" v-b-tooltip="'Vendor already added to MaterialRequest'"></i>
              </div>
            </td>

            <td v-else-if="props.field === 'distance'">
              <span v-if="props.dataItem[props.field] == 0">N/A</span>
              <span v-else>{{ props.dataItem[props.field] }}</span>
            </td>

            <td v-else>
              {{ props.dataItem[props.field] }}
            </td>
            </template>
          </template>
        </grid>
      </div>

      <div class="col-12 mt-2 d-flex justify-content-between">
        <button class="badgebutton ml-2" @click="cancel">
          <i class="far fa-times"></i>
          Cancel
        </button>
        <button class="badgebutton active" @click="selectVendors" :disabled="!addedVendors.length">
          <i class="far fa-plus"></i>
          Select vendors
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Emit, Prop } from 'vue-property-decorator';
  import { GridColumnProps } from '@progress/kendo-vue-grid';
  import { VendorDto } from '@/apiclient/apiclient_generated';
  import { materialRequestClient } from '@/apiclient/opsboardapi';

  @Component({
    components: {},
  })
  export default class SelectVendor extends Vue {
    @Prop() selectedVendors: string[];
    @Prop() materialRequestId: string;

    vendors: VendorDto[] = [];
    addedVendors: string[] = [];

    async mounted() {
      await this.loadData();
    }

    async loadData() {
      this.vendors = await materialRequestClient.getVendorsWithDistance(this.materialRequestId);
    }

    get columns(): GridColumnProps[] {
      return [
        { field: 'selected', width: '50px', title: ' ' },
        { field: 'favorite', width: '30px', title: ' ' },
        { field: 'name', title: 'Name', filterable: false },
        { field: 'email', title: 'E-Mail', filterable: false},
        { field: 'location', title: 'Location', filterable: false},
        { field: 'distance', title: 'Distance in km', filterable: false},
      ];
    }

    @Emit('selectvendors')
    selectVendors() {
      return this.addedVendors;
    }

    @Emit('cancel')
    cancel() {
      return;
    }

    toggleSelection(guid: string) {
      if (this.addedVendors.indexOf(guid) === -1) {
        this.addedVendors.push(guid);
      } else {
        this.addedVendors = this.addedVendors.filter((_) => _ != guid);
      }
    }

    isSelected(guid: string) {
      return this.addedVendors.indexOf(guid) != -1;
    }

    onRowClick(event) {
      this.toggleSelection(event.dataItem.id);
    }
  }
</script>

<style lang="scss" scoped>
  .k-grid td {
    border-width: 0 !important;
  }
</style>
